export default __webpack_public_path__ + "static/media/monitor.971ab7f4.svg";